// extracted by mini-css-extract-plugin
export default {"errorPage":"error_errorPage__7hZ2m"};